import Head from 'next/head'
import { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import dynamic from 'next/dynamic'
import ReactPlayer from 'react-player/lazy'

export default function ApplyPage() {
  const router = useRouter()

  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setLoading(false)
    }
  }, [])

  return (
    <>
      <Head>
        <title>Stream the Combat Warriors Tournament! | Combat Warriors</title>
        <meta name="description" content="Stream the Combat Warriors Tournament!" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />

        <meta property="og:title" content="Stream the Combat Warriors Tournament! | Combat Warriors" />
        <meta property="og:description" content="Stream the first ever official Combat Warriors tournament!" />
      </Head>
      
      {loading ? (
        <div className="flex items-center justify-center w-full h-screen">
          <div className="flex items-center justify-center w-16 h-16 border-t-2 border-b-2 border-gray-500 rounded-full animate-spin"></div>
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center w-full h-screen">
          <div className="relative isolate">
            <div
              className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
              aria-hidden="true"
            >
              <div
                className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-50 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
                style={{
                  clipPath:
                    'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                }}
              />
          </div>
          <div className="mx-auto max-w-2xl text-center">
            <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
              Stream the tournament!
            </h2>

            <div className="mt-6 block md:hidden">
              <ReactPlayer
                url="https://twitch.tv/cwrblx"
                width="100%"
                controls={true}
              />
            </div>

            <div className="mt-6 hidden md:block">
              <ReactPlayer
                url="https://twitch.tv/cwrblx"
                controls={true}
              />
            </div>

            <div className="mt-10 flex items-center justify-center gap-x-6">
              <button
                className="transition rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                onClick={() => router.push('https://twitch.tv/cwrblx')}
              >
                Watch on Twitch
              </button>
            </div>
          </div>
        </div>
        </div>
      )}
    </>
  )
}

export async function getServerSideProps({ req }) {
  return {
    props: {}
  }
}